enum Preferences {
    allow_email_marketing = "allow_email_marketing",
    allow_email_notifications = "allow_email_notifications",
    allow_push_notifications = "allow_push_notifications",
    allow_sms_notifications = "allow_sms_notifications",
    enable_dark_mode = "enable_dark_mode",
    enable_two_factor_auth = "enable_two_factor_auth",
    leaderboard_anonymity = "leaderboard_anonymity",
    leaderboard_visibility = "leaderboard_visibility",
    locale = "locale",
    public_profile = "public_profile",
    group_admin_sharing = "group_admin_sharing",
    group_player_sharing = "group_player_sharing",
    challenges_test_group = "challenges_test_group",
    volume_master = "volume_master",
    volume_music = "volume_music",
    volume_voice = "volume_voice",
    volume_crowd = "volume_crowd",
    feedback_text_scan_critical = "feedback_text_scan_critical",
    feedback_text_decision = "feedback_text_decision",
    feedback_voice_scan_rate = "feedback_voice_scan_rate",
    feedback_voice_scan_timing = "feedback_voice_scan_timing",
    feedback_voice_scan_critical = "feedback_voice_scan_critical",
    feedback_voice_awareness = "feedback_voice_awareness",
    feedback_voice_decision = "feedback_voice_decision",
    haptic_strength = "haptic_strength",
}

export default Preferences;